import React, { FC, useState } from "react";
import {
  IconButton,
  InputAdornment,
  TextField as MuiTextField,
  TextFieldProps,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const TextField: FC<TextFieldProps> = ({ type, ...props }) => {
  const [showPassword, setShowPassword] = useState(false);

  if (type !== "password") {
    return <MuiTextField {...props} type={type} />;
  }

  return (
    <MuiTextField
      {...props}
      type={type === "password" ? (showPassword ? "text" : "password") : type}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() => setShowPassword((prev) => !prev)}
                edge="end"
                // workaround to disable tabbing
                tabIndex={-1}
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
};

export default TextField;
